import { type CustomCellRendererProps } from '@mint-lib/ag-grid/react';
import type { FC } from 'react';

import { useDateFormatter } from '@mint-lib/formatting-hooks';

import type { ApprovalTableItemData } from '../../../types/approversTable.js';
import { parseUTCDate } from '../../../utils/transformers.js';

type Props = CustomCellRendererProps<ApprovalTableItemData, string>;

const DateCell: FC<Props> = ({ value }) => {
  const date = value ? parseUTCDate(value) : undefined;
  const { formattedDateFrom } = useDateFormatter(date);

  if (!formattedDateFrom) {
    return null;
  }

  return formattedDateFrom;
};

export default DateCell;
